import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { TaxApiModelStub } from '../api-models/stubs/TaxApiModel.stub'
import { type TaxApiModel } from '../api-models/TaxApiModel'

export const mockGetTaxesSuccess = (
  taxStubs: TaxApiModel[] = [TaxApiModelStub.build()]
) => {
  return rest.get(`/api/v3/tax/`, (_, res, ctx) => {
    return res.once(ctx.status(200), ctx.json(getResponseObject(taxStubs)))
  })
}

export const mockGetTaxesError = () => {
  return rest.get(`/api/v3/tax/`, (_, res, ctx) => {
    return res.once(ctx.status(400))
  })
}

/**
 * Persistent handler that honors the `is_active` query param so a single
 * registration serves both the Active and Inactive tabs (and survives
 * post-command list invalidation refetches).
 */
export const mockGetTaxesSuccessByActiveState = (
  taxStubs: TaxApiModel[] = [TaxApiModelStub.build()]
) => {
  return rest.get(`/api/v3/tax/`, (req, res, ctx) => {
    const isActive =
      req.url.searchParams.get('is_active')?.toLowerCase() !== 'false'
    const pageSize = Number(req.url.searchParams.get('page_size') || 10)

    const data = taxStubs.filter((stub) => stub.is_active === isActive)

    return res(
      ctx.status(200),
      ctx.json(
        getResponseObject(data, {
          count: data.length,
          page_size: pageSize,
          num_pages: Math.max(1, Math.ceil(data.length / pageSize)),
        })
      )
    )
  })
}
